'use client';

/**
 * 상세 창의 글 카드에 **그 계정 하나의** 얼굴·팔로워를 붙인다 — 목록이 얼굴을 못 붙여 온 카드(소셜 게시물 · 허브 목록 …)도 상세에서는 얼굴이 선다.
 * 발굴 색인(`docs.byIds` · 공짜)만 묻는다 — 유료 실시간 조회(`/api/profiles`)는 창 하나 열 때마다 나가므로 쓰지 않는다.
 * 🔑 이미 얼굴이 있는 카드 · SNS 다섯(`PROFILE_CHANNELS`) 밖 · 공유 페이지는 묻지 않는다 · 못 찾으면 카드 그대로(머리글자).
 */

import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { searchAllKeys } from 'src/query-keys/search-all';
import { fetchInfluencerDocsByIds } from 'src/actions/els/influencer';

import { toProfileDocIds, readAccountProfiles, applyAccountProfiles } from '../../../utils/search-all-media-cards';

import type { MediaCard } from '../../../utils/search-all-media-cards';

const STALE_MS = 5 * 60 * 1000;

/**
 * @param card 상세에 띄운 카드 — 없으면 `null`
 * @param enabled 공유 페이지(비회원)면 끈다
 */
export function useMediaDetailProfile(card: MediaCard | null, enabled = true): MediaCard | null {
  const ids = useMemo(() => (card?.kind === 'organic' && !card.avatar && card.post ? toProfileDocIds([card.post]) : []), [card]);
  const query = useQuery({
    queryKey: searchAllKeys.accountProfiles(ids.join('|')),
    enabled: enabled && ids.length > 0,
    staleTime: STALE_MS,
    queryFn: async () => readAccountProfiles((await fetchInfluencerDocsByIds({ ids })).rows),
  });
  return useMemo(() => (card && query.data ? applyAccountProfiles([card], query.data)[0] : card), [card, query.data]);
}
